'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Currency definition with hints for proper rendering.
 * @typedef {Object} CurrencyDefinition
 * @property {string} code
 *   Currency code according to ISO 4217.
 * @property {number} ratio
 *   Amount of cents in a single unit.
 * @property {boolean} [customCurrency]
 *   Whether currency is regular or our custom created
 */

/**
 * Chinese yuan currency definition
 * @name CNY
 * @kind constant
 * @type {CurrencyDefinition}
 */
var CNY = {
  code: 'CNY',
  customCurrency: false,
  ratio: 100,
  symbol: '¥'
  /**
   * Great British Pound currency definition
   * @name GBP
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var GBP = {
  code: 'GBP',
  customCurrency: false,
  ratio: 100,
  symbol: '£'
  /**
   * Euro currency definition
   * @name EUR
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var EUR = {
  code: 'EUR',
  customCurrency: false,
  ratio: 100,
  symbol: '€'
  /**
   * Korean won currency definition
   * @name KRW
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var KRW = {
  code: 'KRW',
  customCurrency: false,
  ratio: 100,
  symbol: '₩'
  /**
   * Norwegian krone currency definition
   * @name NOK
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var NOK = {
  code: 'NOK',
  customCurrency: false,
  ratio: 100,
  symbol: 'kr'
  /**
   * Russian ruble currency definition
   * @name RUB
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var RUB = {
  code: 'RUB',
  customCurrency: false,
  ratio: 100,
  symbol: 'RUB'
  /**
   * Swedish krona currency definition
   * @name SEK
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var SEK = {
  code: 'SEK',
  customCurrency: false,
  ratio: 100,
  symbol: 'kr'
  /**
   * United States dollar currency definition
   * @name USD
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var USD = {
  code: 'USD',
  customCurrency: false,
  ratio: 100,
  symbol: '$'
  /**
   * Danish krona currency definition
   * @name DKK
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var DKK = {
  code: 'DKK',
  customCurrency: false,
  ratio: 100,
  symbol: 'kr'
  /**
   * Indian rupee currency definition
   * @name INR
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var INR = {
  code: 'INR',
  customCurrency: false,
  ratio: 100,
  symbol: '₹'
  /**
   * Canadian currency definition
   * @name CAD
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var CAD = {
  code: 'CAD',
  customCurrency: false,
  ratio: 100,
  symbol: 'C$'
  /**
   * Millibitcoin currency definition
   * @name MBT
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var MBT = {
  code: 'MBT',
  customCurrency: true,
  ratio: 100,
  symbol: 'm₿'
  /**
   * Microbitcoin currency definition
   * We're getting UBT (microbitcoin) cents from BE and converting it
   * to MBT (millibitcoin)
   * @name UBT
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var UBT = {
  code: 'UBT',
  customCurrency: true,
  ratio: 100000,
  symbol: 'm₿'
  /**
   * Bitcoin currency definition
   * We're getting UBT (microbitcoin) cents from BE and converting it
   * to BTC (bitcoin)
   * @name BTC
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var BTC = {
  code: 'BTC',
  customCurrency: true,
  ratio: 100000000,
  symbol: '₿'
  /**
   * Bitcoin currency definition
   * We're getting XBT (bitcoin) cents from PiQ for pending transactions
   * and converting it to MBT (millibitcoin)
   * @name XBT
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var XBT = {
  code: 'XBT',
  customCurrency: true,
  ratio: 0.1,
  symbol: 'm₿'
  /**
   * Japaneese Yen currency definition
   * @name JPY
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var JPY = {
  code: 'JPY',
  customCurrency: false,
  ratio: 100,
  symbol: '¥'
  /**
   * Brasilian Real currency definition
   * @name BRL
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var BRL = {
  code: 'BRL',
  customCurrency: false,
  ratio: 100,
  symbol: 'R$'
  /**
   * New Zealand Dollar currency definition
   * @name NZD
   * @kind constant
   * @type {CurrencyDefinition}
   */

};
var NZD = {
  code: 'NZD',
  customCurrency: false,
  ratio: 100,
  symbol: 'NZ$'
};

exports.BRL = BRL;
exports.BTC = BTC;
exports.CAD = CAD;
exports.CNY = CNY;
exports.DKK = DKK;
exports.EUR = EUR;
exports.GBP = GBP;
exports.INR = INR;
exports.JPY = JPY;
exports.KRW = KRW;
exports.MBT = MBT;
exports.NOK = NOK;
exports.NZD = NZD;
exports.RUB = RUB;
exports.SEK = SEK;
exports.UBT = UBT;
exports.USD = USD;
exports.XBT = XBT;
//# sourceMappingURL=currencies.js.map
